<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template v-slot:header>
              <h4 class="card-title">{{ title }}</h4>
              <p class="card-category">{{ description }}</p>
            </template>

            <div class="row">
              <!-- <div class="col-md-4">
                <div class="form-group">
                  <label for="finder">Búsqueda</label>
                  <div class="input-group">
                    <input type="text" v-model="finder" @keyup="loadElements" class="form-control custom-placeholder"
                      :placeholder="finderLabel" id="finder" />

                  </div>
                </div>
              </div> -->

              <!-- <div class="col-md-4">
                <label class="custom-placeholder">Filtrar por tipo</label>
                <multiselect v-model="filter_stocks" label="code" class="custom-rounded-multiselect text-capitalize"
                  :options="stockTmp" @select="loadElements" @remove="loadElements" selectLabel="Click/enter para elegir"
                  selectedLabel="Seleccionado" deselectLabel="Click/Enter para remover" :searchable="true"
                  :placeholder="filterLabel" placeholder-class="custom-placeholder"></multiselect>

              </div> -->

              <!-- <div class="col-md-4 d-flex align-items-end justify-content-end">
                <button type="button" data-toggle="tooltip" data-placement="top" title="Crear nuevo"
                  class="btn btn-fill float-right  btn-info" @click.prevent="goNew">
                  <span style="color: white">
                    <v-icon name="plus" class="mx-1" fill="white"></v-icon>
                    {{ buttonNewLabel }}
                  </span>
                </button>
              </div> -->
            </div>

            <div class="row mt-3">
              <div class="col-md-12 p-0">
                <div class="row px-3">
                  <div v-for="platform in Platforms" :key="platform.id" class="col-12 col-md-6 col-lg-4 mb-4">
                    <div class="postulation-card shadow-sm border-0 h-100 d-flex flex-column">
                      <!-- Image Section -->
                      <div class="position-relative overflow-hidden" style="border-radius: 15px 15px 0 0; background: #f8f9fa;">
                        <img
                          :src="platform.platform?.url_banner || platform.platform?.url_image || '/img/ccdlogolite.png'"
                          class="card-img-top"
                          alt="Platform logo"
                          style="height: 180px; object-fit: cover; width: 100%;"
                          @error="handleImageError($event)"
                        />
                      </div>

                      <div class="card-body d-flex flex-column p-4">
                        <div class="mb-3">
                          <h5 class="card-title fw-bold text-dark mb-1" style="font-size: 1.1rem; line-height: 1.4; min-height: 3rem;">
                            {{ platform.platform?.name || 'Postulación sin nombre' }}
                          </h5>
                          
                          <!-- Estatus de Postulación -->
                          <div class="mt-2">
                            <small class="text-muted d-block mb-1" style="font-size: 0.7rem; font-weight: 600;">Estatus de Postulación:</small>
                            <span
                              class="payment-status-tag"
                              :class="getPaymentStatusBadgeClass(platform.id_type_status)"
                            >
                              {{ platform.type_status?.name || 'Pendiente' }}
                            </span>
                          </div>

                          <!-- Payment Status (Separated) -->
                          <div v-if="platform.type_status_payment" class="mt-2">
                            <small class="text-muted d-block mb-1" style="font-size: 0.7rem; font-weight: 600;">Estatus de Pago:</small>
                            <span
                              class="payment-status-tag"
                              :class="getPaymentStatusBadgeClass(platform.id_type_status_payment)"
                            >
                              <font-awesome-icon :icon="['fas', 'dollar-sign']" class="me-1" style="font-size: 11px;" />
                              {{ platform.type_status_payment?.name || 'Pago' }}
                            </span>
                          </div>
                        </div>

                        <p class="text-muted mb-1 mt-auto d-flex align-items-center" style="font-size: 0.7rem;">
                          <font-awesome-icon :icon="['fas', 'calendar-plus']" class="me-2" style="font-size: 11px;" />
                          <span>Creado: {{ formatDate(platform.created_at) }}</span>
                        </p>
                        <p class="text-muted mb-0 d-flex align-items-center" style="font-size: 0.7rem;">
                          <font-awesome-icon :icon="['fas', 'calendar-alt']" class="me-2" style="font-size: 11px;" />
                          <span>Actualizado: {{ formatDate(platform.updated_at) }}</span>
                        </p>
                        
                        <!-- Action Buttons -->
                        <div class="mt-4 d-flex justify-content-between gap-2 pt-3 border-top">
                          <button
                            class="btn btn-sm action-btn btn-view flex-grow-1"
                            @click="openUploadElement(platform)"
                            title="Ver detalles"
                          >
                            <font-awesome-icon :icon="['fas', 'eye']" style="font-size: 14px;" />
                            <span>{{ platform.id_type_status == 3 ? ' Ver postulación' : ' Ver requisitos' }}</span>
                          </button>
                          <button
                            class="btn btn-sm action-btn btn-payment flex-grow-1"
                            :style="platform.id_type_status === 1 ? 'opacity: 0.5; filter: grayscale(1);' : ''"
                            @click="openModalPayment(platform)"
                            title="Reportar pago"
                          >
                            <font-awesome-icon :icon="['fas', 'money-bill-wave']" style="font-size: 14px;" />
                            <span> Pago</span>
                          </button>
                          <button
                            class="btn btn-sm action-btn btn-delete px-3"
                            @click="deleteStatus(platform)"
                            title="Eliminar"
                          >
                            <font-awesome-icon :icon="['fas', 'trash']" style="font-size: 14px;" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="Platforms.length === 0" class="col-12 text-center py-5">
                    <font-awesome-icon :icon="['fas', 'folder-open']" style="font-size: 40px; color: #ccc;" />
                    <p class="mt-3 text-muted">No tienes postulaciones registradas actualmente.</p>
                  </div>
                </div>

                <!-- MODAL UPLOAD IMAGE -->
                <div
                  :class="[
                    'custom-modal-payment',
                    modalActiveUpdate
                      ? 'modal fade show disable-scroll'
                      : 'modal fade',
                  ]"
                  :id="'modalPostulation'"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    class="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div class="modal-content p-0">
                      <div class="modal-header custom-header">
                        <h2
                          class="modal-title w-100 text-center m-0 text-white"
                        >
                          Requisitos
                        </h2>
                        <button
                          type="button"
                          class="close custom-close"
                          data-dismiss="modal"
                          aria-label="Close"
                          @click.prevent="closeUploadElement"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body p-4 modal-body-scroll">
                        <form>
                          <div class="row g-3">
                            <div class="col-12 mb-3">
                              <div class="card shadow-sm border-0">
                                <div class="card-body py-3 px-3">
                                  <h6 class="fw-bold mb-2" v-if="form_update.platform.requires">
                                    Requisitos para participar
                                  </h6>
                                  <ul
                                    v-if="form_update.platform.requires"
                                    class="list-unstyled mb-0"
                                    style="font-size: 0.82rem; line-height: 1.45; color: #444;"
                                  >
                                    <li
                                      v-for="(req, index) in form_update.platform.requires.split('\r\n')"
                                      :key="index"
                                      class="d-flex align-items-start mb-1"
                                    >
                                      <span class="me-2">•</span>
                                      <span>{{ req }}</span>
                                    </li>
                                  </ul>
                                  <p
                                    v-else
                                    class="text-muted mb-0 fst-italic"
                                    style="font-size: 0.82rem;"
                                  >
                                    No se registraron requisitos para este curso.
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="card shadow-sm border-0 d-flex flex-column">
                                <div class="card-body py-3 px-3 d-flex flex-column">
                                  <div
                                    class="mb-2 d-flex flex-column"
                                  >
                                    <h6 class="fw-bold mb-1">Tus archivos</h6>
                                    <p class="text-muted small mb-2">
                                      Sube tus archivos para cumplir con los requisitos
                                    </p>
                                  </div>

                                  <div
                                    v-if="filesUser && filesUser.length > 0"
                                    class="mb-3"
                                  >
                                    <div
                                      v-for="item in filesUser"
                                      :key="item.id"
                                      class="d-flex align-items-center justify-content-between py-1 px-2 rounded-3 mb-1 bg-light"
                                      v-if="
                                        (form_update.id_type_status == 1 &&
                                          filesUser &&
                                          filesUser.length > 0) ||
                                        (form_update.id_type_status == 2 &&
                                          filesUser &&
                                          filesUser.length > 0)
                                      "
                                    >
                                      <a
                                        :href="item.url_file"
                                        target="_blank"
                                        class="text-decoration-none text-dark small text-truncate me-2"
                                      >
                                        {{ item.name }}
                                      </a>
                                      <button
                                        type="submit"
                                        class="btn btn-sm bg-gradient-fvf-switch rounded-circle d-flex align-items-center justify-content-center"
                                        style="
                                          width: 32px;
                                          height: 32px;
                                          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
                                        "
                                        @click.prevent="deleteFile(item.id)"
                                      >
                                        <font-awesome-icon
                                          :icon="['fas', 'trash']"
                                          style="color: #CE0D0D; font-size: 16px;"
                                        ></font-awesome-icon>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="mt-auto" v-if="
                                    form_update.id_type_status == 1 ||
                                    form_update.id_type_status == 2
                                  ">
                                    <file-pond
                                      ref="filePond"
                                      name="image"
                                      v-model="form_save.url_file"
                                      allow-multiple="true"
                                      class="w-100 h-100 mb-2"
                                      label-idle="Arrastre o seleccione los archivos"
                                    ></file-pond>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div
                        class="modal-footer border-0 mt-2 px-4 pb-4 justify-content-end"
                        v-if="form_update.id_type_status == 1 || form_update.id_type_status == 2"
                      >
                        <button
                          type="button"
                          class="btn btn-sm btn-info btn-fill px-4"
                          @click.prevent="uploadFiles"
                        >
                          Subir
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- MODAL PAYMENT REPORT -->
                <div
                  :class="[
                    'custom-modal-payment',
                    selectorOpen
                      ? 'modal fade show disable-scroll'
                      : 'modal fade show',
                  ]"
                  :id="'modalPayment'"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    class="modal-dialog modal-dialog-centered modal-lg"
                    role="document"
                  >
                    <div class="modal-content p-0" style="overflow: visible !important; border-radius: 15px; border: none;">
                      <div class="modal-header custom-header" style="border-radius: 15px 15px 0 0;">
                        <h2 class="modal-title w-100 text-center m-0 text-white">
                          Reporte de Pago
                        </h2>
                        <button
                          type="button"
                          class="close custom-close"
                          data-dismiss="modal"
                          aria-label="Close"
                          @click.prevent="closePaymentElement"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <!-- Información de pago -->
                      <div
                        class="row payment-information-header px-4 py-3 text-white"
                        style="background: #351020; margin: 0;"
                      >
                        <div class="col-12 col-md-6">
                          <p class="mb-0 text-white">
                            <strong>Curso: </strong>
                            <span class="text-white">{{
                              form_update.platform.name
                            }}</span>
                          </p>
                          <p class="mb-0 text-white">
                            <strong>Inversión: </strong>
                            <span class="text-white"
                              >${{ amountFormatted }}</span
                            >
                          </p>
                          <p class="mb-0 text-white">
                            <strong>Tasa BCV: </strong>
                            <span class="text-white"
                              >Bs.{{ bcvRateFormatted }}</span
                            >
                          </p>
                          <p class="mb-0 text-white">
                            <strong>Total a pagar: </strong>
                            <span class="text-white">Bs.{{ totalPaymentAmountFormatted }}</span>
                          </p>
                        </div>
                        <div
                          class="col-12 col-md-6 text-white"
                          v-if="form_payment.id_company_bank"
                        >
                          <p class="mb-0 text-white">
                            <strong>Datos para el pago:</strong>
                          </p>
                          <p class="mb-0 text-white">
                            <strong>Razón Social :</strong>
                            <span class="text-white">{{ form_payment.id_company_bank.holder_bank }}</span>
                          </p>
                          <p class="mb-0 text-white">
                            <strong>Banco :</strong>
                            <span class="text-white">{{ form_payment.id_company_bank.name_bank }}</span>
                          </p>
                          <p class="mb-0 text-white">
                            <strong>Nro Cuenta :</strong>
                            <span class="text-white">{{ form_payment.id_company_bank.account }}</span>
                          </p>
                          <p class="mb-0 text-white">
                            <strong>RIF:</strong>
                            <span class="text-white">{{ form_payment.id_company_bank.dni }}</span>
                          </p>
                        </div>
                      </div>
                      <div
                        class="modal-body px-4 py-4"
                        style="overflow: visible !important; background: white; border-radius: 0 0 15px 15px; height: auto !important; max-height: none !important;"
                      >
                        <form>
                          <div class="row g-2">
                            <div class="col-12 col-md-6 mb-3">
                              <label class="form-label fw-bold text-dark">Banco de destino</label>
                              <multiselect
                                v-model="form_payment.id_company_bank"
                                label="name_bank"
                                :options="companyBank"
                                :searchable="true"
                                placeholder="Banco de destino"
                                class="custom-input"
                              ></multiselect>
                            </div>
                            <div class="col-12 col-md-6 mb-3">
                              <label class="form-label fw-bold text-dark">Fecha de pago</label>
                              <input v-model="form_payment.date" type="date" class="form-control" />
                            </div>
                            <div class="col-12 col-md-6 mb-3">
                              <label class="form-label fw-bold text-dark">Moneda</label>
                              <multiselect
                                v-model="form_payment.currency"
                                :options="currencyOptions.map(c => c.code)"
                                :custom-label="opt => currencyOptions.find(c => c.code === opt)?.name || opt"
                                placeholder="Selecciona la moneda"
                                class="custom-input"
                                :allow-empty="false"
                              ></multiselect>
                            </div>
                            <div
                              class="col-12 col-md-6 mb-3"
                              v-if="form_payment.id_company_bank"
                            >
                              <label class="form-label fw-bold text-dark">Banco emisor</label>
                              <multiselect
                                v-model="form_payment.origin_bank"
                                label="name"
                                track-by="id"
                                :options="banks_nationals"
                                :searchable="true"
                                placeholder="Selecciona banco emisor"
                                class="custom-input"
                                :allow-empty="false"
                              ></multiselect>
                            </div>
                            <div
                              class="col-12 col-md-6 mb-3"
                              v-if="form_payment.id_company_bank"
                            >
                              <base-input
                                type="text"
                                label="Referencia"
                                label-class="text-dark fw-bold"
                                placeholder="Referencia"
                                v-model="form_payment.reference"
                                class="custom-input mb-0"
                                pattern="[0-9]*"
                                inputmode="numeric"
                                @input="
                                  form_payment.reference =
                                    form_payment.reference.replace(
                                      /[^0-9]/g,
                                      ''
                                    )
                                "
                              ></base-input>
                            </div>
                            <div
                              class="col-12 col-md-6 mb-3"
                              v-if="form_payment.id_company_bank"
                            >
                              <base-input
                                type="text"
                                :label="form_payment.currency === 'USD' ? 'Monto de pago ($)' : 'Monto de pago (Bs.)'"
                                label-class="text-dark fw-bold"
                                :placeholder="form_payment.currency === 'USD' ? 'Monto en Dólares' : 'Monto en Bolívares'"
                                v-model="amountWithPrefix"
                                class="custom-input mb-0"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                @keypress="!/[0-9]/.test($event.key) && $event.preventDefault()"
                              ></base-input>
                            </div>
                           
                          </div>
                          <div
                            class="mt-md-0"
                            v-if="form_payment.id_company_bank"
                          >
                            <label class="form-label text-dark">Captura de pago</label>
                            <file-pond
                              ref="filePondPayment"
                              name="capture"
                              v-model="form_payment.url_image"
                              allow-multiple="true"
                              label-idle="Arrastre o seleccione la captura del pago"
                            ></file-pond>
                          </div>
                          <div class="row mt-4">
                            <div class="col-12">
                              <button
                                type="button"
                                class="btn golden-btn w-100"
                                @click="savePayment"
                              >
                                Reportar Pago
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function clearAccents(cadena) {
  let chars = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ñ: "n",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
    À: "A",
    È: "E",
    Ì: "I",
    Ò: "O",
    Ù: "U",
    Ñ: "N",
  };
  let expr = /[áàéèíìóòúùñ]/gi;
  let res = cadena.replace(expr, function (e) {
    return chars[e];
  });
  return res;
}

function parseEsNumber(input) {
  if (input === null || input === undefined) return 0;
  if (typeof input === "number") return isNaN(input) ? 0 : input;
  const str = String(input).trim();
  if (!str) return 0;
  // Permitir que venga con prefijos como "$" o "Bs.", espacios, etc.
  // Dejamos solo dígitos y separadores decimales/miles.
  const cleaned = str.replace(/[^0-9.,-]/g, "");

  // Soportar:
  // - "32.539,00" (es-VE: miles con '.', decimales con ',')
  // - "325,39" (decimales con ',')
  // - "325.39" (backend puede enviar decimales con '.')
  const hasDot = cleaned.includes(".");
  const hasComma = cleaned.includes(",");

  let normalized = cleaned;
  if (hasDot && hasComma) {
    const lastDot = cleaned.lastIndexOf(".");
    const lastComma = cleaned.lastIndexOf(",");
    if (lastComma > lastDot) {
      // 32.539,00 -> 32539.00
      normalized = cleaned.replace(/\./g, "").replace(/,/g, ".");
    } else {
      // 32,539.00 -> 32539.00
      normalized = cleaned.replace(/,/g, "");
    }
  } else if (hasComma) {
    // 325,39 -> 325.39
    normalized = cleaned.replace(/,/g, ".");
  } else if (hasDot) {
    // 325.39 -> 325.39 (asumimos '.' decimal si es el único separador)
    normalized = cleaned;
  }

  const n = Number(normalized);
  return isNaN(n) ? 0 : n;
}

import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import LTable from "src/components/Table.vue";
import Card from "src/components/Cards/Card.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Cookies from "js-cookie";
import moment, { max } from "moment";
import { Modal } from "bootstrap";

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    LTable,
    Card,
    Multiselect,
    FilePond
  },
  data() {
    return {
      //LABELS
      title: "Mis postulaciones",
      description:
        "Podrás gestionar tus postulaciones registradas en el sistema",
      buttonNewLabel: "Agregar nuevo usuario",
      buttonNewUrl: "UserIDNew",
      buttonEditUrl: "UserIDEdit",
      finderLabel: "Buscar",
      filterLabel: "Seleccione",
      listVisible: false,
      selectorOpen: false,
      //FILTERS
      filter_stocks: "",
      //VARIABLE
      finder: "",
      metaInfo: {},
      isBusy: false,
      //MODAL
      modalActiveUpdate: false,
      idTmp: 0,
      filesUser: [],
      bcvRate: {},
      companyBank: [],
      banks_nationals: [],
      totalPaymentAmount: 0,
      amountWithDecimals: 0,

      id_user: Cookies.get("id"),

      form_payment: {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
        currency: "VES",
      },
      currencyOptions: [
        { code: "VES", name: "Bolívares (Bs)", symbol: "Bs." },
        { code: "USD", name: "Dólares ($)", symbol: "$" },
      ],

      form_save: {
        id_user_platform: "",
        name: "",
        url_file: "",
      },

      form_update: {
        id: 0,
        name: "",
        url: "",
        url_banner: "",
        url_image: "",
        description: "",
        autoapproved: "",
        platform: {
          name: "",
          amount: 0,
        },
        requires: "",
        id_type_status: "",
        id_type_status_payment: "",
      },

      data: [
        {
          profile_image: "../img/faces/face-0.jpg",
        },
        // ... otros objetos de datos ...
      ],
      //TABLE DATA
      tableData: {
        columns: [
          {
            name: "",
            key: "platform.url_image",
            type: "image",
          },
          {
            name: "Postulación",
            key: "platform.name",
          },
          {
            name: "Estado",
            key: "type_status.name",
          },
          {
            name: "Última actualización",
            key: "updated_at",
          },
          {
            name: "Acciones",
            key: "actions",
          },
        ],
        data: [],
      },
      //DATA Variables
      Platforms: [],
      stockTmp: [],
      //TABLE Buttons
      buttons: [
        {
          icon: "eye",
          icon_negative: "eye",
          type_button: "btn-info",
          tooltip: "Ver postulación",
          url: "",
          type_action: "go_method",
          action: "openUploadElement",
          fill_icon: "#FFC700",
        },
        {
          icon: "money-bill-wave",
          icon_negative: "check-square",
          type_button: "btn-danger",
          tooltip: "Reportar pago",
          url: "",
          type_action: "go_method",
          action: "openModalPayment",
          fill_icon: "#003068",
        },
        {
          icon: "trash",
          icon_negative: "trash",
          type_button: "btn-danger",
          tooltip: "Eliminar postulación",
          url: "",
          type_action: "go_method",
          action: "deleteStatus",
          fill_icon: "#CE0D0D",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    rows() {
      return this.PlatformsTmp.length;
    },
    amountWithPrefix: {
      get() {
        const symbol = this.form_payment.currency === 'USD' ? '$' : 'Bs.';
        const locale = this.form_payment.currency === 'USD' ? 'en-US' : 'es-VE';
        return `${symbol} ${(this.form_payment.amount / 100).toLocaleString(locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
      set(newValue) {
        const value = newValue.replace(/[^0-9]/g, "");
        this.form_payment.amount = value;
        this.amountWithDecimals = parseFloat(value / 100).toFixed(2);
      },
    },
    amountFormatted() {
      if (this.form_update?.course_amount === null || this.form_update?.course_amount === undefined) return "";
      const value = parseEsNumber(this.form_update.course_amount);
      if (!value && value !== 0) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    bcvRateFormatted() {
      if (!this.bcvRate.value) return "";
      const value = parseEsNumber(this.bcvRate.value);
      if (!value && value !== 0) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    totalPaymentAmountFormatted() {
      if (this.totalPaymentAmount === null || this.totalPaymentAmount === undefined) {
        return "";
      }
      const value = Number(this.totalPaymentAmount);
      if (isNaN(value)) return "";
      return value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  mounted() {
    this.loadElements();
    this.loadBcvRate();
    this.loadCompanyBank();
    this.loadBanksNationals();
  },
  updated() {
    // console.log(this.user);
  },
  methods: {
    ...mapActions([
      "getData",
      "getDataLite",
      "changeStatusData",
      "updateData",
      "createData",
    ]),

    loadBanksNationals() {
      let form = {
        url: "master/type_banks/all",
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.banks_nationals = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
          alert("Ocurrió un error, intente más tarde");
        });
    },

    formatDate(date) {
      if (!date) return 'Sin fecha';
      // Handle both native Date strings and moment objects
      // El backend suele enviar timestamps en UTC; convertimos a hora local.
      let m;
      if (moment.isMoment(date)) {
        m = date.clone().local();
      } else {
        const hasTimezoneInfo =
          typeof date === "string" && /Z$|[+-]\d{2}:?\d{2}$/.test(date);
        m = hasTimezoneInfo
          ? moment.parseZone(date).local()
          : moment.utc(date).local();
      }

      if (m && m.isValid()) {
        return m.format("DD/MM/YYYY HH:mm");
      }
      return 'Sin fecha';
    },

    handleImageError(event) {
      const defaultImg = '/img/ccdlogolite.png';
      if (event.target.src.indexOf(defaultImg) === -1) {
        event.target.src = defaultImg;
      }
    },

    getStatusBadgeClass(statusId) {
      switch (statusId) {
        case 1:
          return "badge-pending"; // Pendiente/Borrador
        case 3:
          return "badge-approved"; // Aprobado (Basado en lógica del controlador)
        case 2:
          return "badge-rejected"; // Rechazado
        case 4:
          return "badge-info"; // En revisión
        default:
          return "badge-secondary";
      }
    },

    getPaymentStatusBadgeClass(statusId) {
      switch (statusId) {
        case 1:
          return "payment-tag-pending"; // Pago Pendiente
        case 3:
          return "payment-tag-paid"; // Pagado
        case 2:
          return "payment-tag-rejected"; // Rechazado
        case 4:
          return "payment-tag-process"; // En proceso (O incompleto)
        default:
          return "payment-tag-pending";
      }
    },

    savePayment() {
      const originBankValue =
        this.form_payment && typeof this.form_payment.origin_bank === "object"
          ? (this.form_payment.origin_bank?.name ||
              this.form_payment.origin_bank?.name_bank ||
              "")
          : (this.form_payment?.origin_bank || "");

      if (this.form_payment.id_company_bank == "") {
        Swal.fire({
          title: "Seleccione un banco",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (!originBankValue) {
        Swal.fire({
          title: "Ingrese el banco emisor",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.date == "") {
        Swal.fire({
          title: "Seleccione la fecha del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.amount == 0) {
        Swal.fire({
          title: "Ingrese el monto pagado",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.reference == "") {
        Swal.fire({
          title: "Ingrese la referencia del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else {
        Swal.fire({
          title: "¿Estás seguro de reportar este pago?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Sí, reportar",
        }).then((result) => {
          if (result.value) {
            let data_form;
            data_form = new FormData();
            data_form.append("id_user", this.id_user);
            data_form.append("id_user_platform", this.form_update.id);
            data_form.append(
              "id_company_bank",
              this.form_payment.id_company_bank.id
            );
            data_form.append("id_bcv_rate", this.bcvRate.id);
            data_form.append("reference", this.form_payment.reference);
            data_form.append("origin_bank", originBankValue);
            data_form.append("amount", this.amountWithDecimals);
            data_form.append(
              "date",
              new Date(this.form_payment.date).toISOString().slice(0, 10)
            );
            data_form.append("phone", this.form_payment.phone);
            data_form.append("currency", this.form_payment.currency);
            const filePondInstance = this.$refs.filePondPayment.getFiles();
            if (filePondInstance && filePondInstance.length > 0) {
              const file = filePondInstance[0].file;
              data_form.append("url_image", file);
            }
            let form = {
              url: "user/payment_report/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.closePaymentElement();
                  Swal.fire({
                    title: "Pago registrado correctamente",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                  this.loadElements();
                }
              })
              .catch((error) => {
                console.log(error);
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }
    },

    handleOpenChange() {
      console.log("OPEN DATE SELECTOR");
      this.selectorOpen = true;
    },

    handleCloseChange() {
      console.log("CLOSE DATE SELECTOR");
      this.selectorOpen = false;
    },

    disableFutureDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    showList() {
      this.listVisible = true;
    },

    goNew() {
      this.$router.push({ name: this.buttonNewUrl });
    },

    openUploadElement(data) {
      if (data.id_type_status == 3 && data.id_type_status_payment == 3) {
        Swal.fire({
          title: "Postulación aprobada",
          text: "Ya puedes acceder a la curso",
          icon: "success",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });

        this.$router.push({ path: "platform/" + data.id_platform });
      } else if (
        data.id_type_status == 3 &&
        (data.id_type_status_payment == 1 || data.id_type_status_payment == 0)
      ) {
        Swal.fire({
          title: "Postulación aprobada",
          text: "Ya puedes realizar el pago para acceder a la curso",
          icon: "success",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        this.$router.push({ path: "platform/" + data.id_platform });
      } else if (data.id_type_status == 3 && data.id_type_status_payment == 2) {
        Swal.fire({
          title: "Hubo un problema con tu pago",
          text: "Parece que tu pago fue rechazado, por favor, cree un nuevo reporte de pago y chequee que los datos son correctos para acceder a la curso",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        // this.$router.push({ path: "platform/" + data.id_platform });
      } else if (data.id_type_status == 3 && data.id_type_status_payment == 4) {
        Swal.fire({
          title: "Hubo un problema con tu pago",
          text: "Parece que tu pago estaba incompleto, por favor, pague el diferencial para acceder a la curso",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        // this.$router.push({ path: "platform/" + data.id_platform });
      } else {
        this.loadUserFiles(data);
        this.form_update = data;
        this.idTmp = data.id;
        console.log("OPEN UPLOAD MODAL");
        setTimeout(() => {
          const modalEl = document.getElementById("modalPostulation");
          if (modalEl) {
            const modalInstance = Modal.getOrCreateInstance(modalEl);
            modalInstance.show();
          }
        }, 100); // tiempo en milisegundos

        this.modalActiveUpdate = true;
      }
    },

    closeUploadElement() {
      console.log("CLOSING UPLOAD MODAL");
      const modalEl = document.getElementById("modalPostulation");
      if (modalEl) {
        const modalInstance = Modal.getOrCreateInstance(modalEl);
        modalInstance.hide();
      }
      this.modalActiveUpdate = false;
    },

    async openModalPayment(data) {
      if (data.id_type_status === 1) {
        Swal.fire({
          title: "Postulación pendiente de aprobación",
          text: "Primero debes esperar que tu postulación sea aprobada, para proceder con el pago.",
          icon: "warning",
          confirmButtonColor: "#B49B57",
        });
        return;
      }
      this.form_update = data;
      this.idTmp = data.id;

      // Asegurar tasa BCV cargada
      if (!this.bcvRate || this.bcvRate.value === undefined || this.bcvRate.value === null) {
        await this.loadBcvRate();
      }

      // En el listado de postulaciones muchas veces NO viene el monto real del curso.
      // Traemos el detalle del curso por id_platform para obtener amount.
      if (data && data.id) {
        try {
          const platformParams = {
            url: "user/user_platform/" + data.id,
            params: {
              active: 1,
              order_by: "id",
              order_value: "desc",
            },
          };
          const resp = await this.getData(platformParams);
          if (resp && resp.code === 200 && resp.data) {
            // `user/user_platform/:id` retorna amount en la raíz
            this.form_update.platform.amount = resp.data.amount;
            this.form_update.platform.name = resp.data.name || this.form_update.platform.name;
            this.form_update.course_amount =
              resp.data.course_amount !== undefined && resp.data.course_amount !== null
                ? resp.data.course_amount
                : (resp.data.amount !== undefined && resp.data.amount !== null
                    ? resp.data.amount
                    : this.form_update.course_amount);
          }
        } catch (e) {
          console.log(e);
        }
      }

      const numericAmount = parseEsNumber(this.form_update?.course_amount || 0);
      const numericBcv = parseEsNumber(this.bcvRate?.value);
      this.totalPaymentAmount = numericAmount * numericBcv;

      console.log("OPEN PAYMENT MODAL", {
        amount: this.form_update?.platform?.amount,
        bcv: this.bcvRate?.value,
        total: this.totalPaymentAmount,
      });

      setTimeout(() => {
        const modalEl = document.getElementById("modalPayment");
        if (modalEl) {
          const modalInstance = Modal.getOrCreateInstance(modalEl);
          modalInstance.show();
        }
      }, 100); // tiempo en milisegundos
      this.modalActiveUpdate = true;
    },

    closePaymentElement() {
      console.log("CLOSING PAYMENT MODAL");
      const modalEl = document.getElementById("modalPayment");
      if (modalEl) {
        const modalInstance = Modal.getOrCreateInstance(modalEl);
        modalInstance.hide();
      }
      this.form_payment = {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
        currency: "VES",
      };
      this.modalActiveUpdate = false;
    },

    loadUserFiles(data) {
      if (data.id_type_status != 3) {
        let data_params = {
          url: "user_file_platform/all",
          params: {
            active: 1,
            id_user_platform: data.id,
            order_by: "id",
            order_value: "asc",
          },
        };

        this.getData(data_params)

          .then((response) => {
            if (response.code == 200) {
              this.filesUser = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    loadBcvRate() {
      let data_params = {
        url: "bcv_rate/all",
        params: {
          active: 1,
          order_by: "id",
          order_value: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.bcvRate = response.data[0];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCompanyBank() {
      let data_params = {
        url: "user/company_bank/all",
        params: {
          active: 1,
          order_by: "id",
          order_value: "asc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.companyBank = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteFile(id) {
      Swal.fire({
        title: "¿Estás seguro de eliminar este archivo?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#048224ff",
        cancelButtonColor: "#abb2ba",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar",
      }).then((result) => {
        if (result.value) {
          let form = {
            url: "user_file_platform/change_status",
            id: id,
            status: 2,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserFiles(this.form_update);
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
            });
        }
      });
    },

    loadElements() {
      let form = {
        url: "user/user_platform/all",
        params: {
          active: 1,
          page: 1,
          limit: 10,
          order_value: "updated_at",
          order_value: "desc",
          // id_user: Cookies.get("id"),
        },
      };

      if (this.metaInfo.current_page > 1) {
        form.params.page = this.metaInfo.current_page;
      }

      if (this.finder != "") {
        console.log("Searching:" + this.finder);
        form.params.query = this.finder;
        form.params.page = 1;
      }
      this.isBusy = true;
      this.getData(form)
        .then(async (response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.Platforms = response.data.data;
            this.metaInfo = response.data.meta;
            this.PlatformsTmp = this.Platforms;

            for (let i = 0; i < this.Platforms.length; i++) {
              const platform = this.Platforms[i];
              if (platform.id_platform) {
                try {
                  const platformResp = await this.getData({
                    url: "user/platform/" + platform.id_platform,
                  });
                  if (platformResp && platformResp.code === 200 && platformResp.data) {
                    if (this.Platforms[i] && this.Platforms[i].platform) {
                      this.Platforms[i].platform.url_image = platformResp.data.url_image || this.Platforms[i].platform.url_image;
                      this.Platforms[i].platform.url_banner = platformResp.data.url_banner || this.Platforms[i].platform.url_banner;
                    }
                  }
                } catch (e) {
                  console.log(e);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    uploadFiles() {
      const filePondInstance = this.$refs.filePond.getFiles();
      if (filePondInstance && filePondInstance.length > 0) {
        Swal.fire({
          title: "Subiendo archivos...",
          icon: "info",
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const promises = [];
        for (let i = 0; i < filePondInstance.length; i++) {
          let data_form;
          data_form = new FormData();
          const file = filePondInstance[i].file;
          const fileName = file.name;
          data_form.append("url_file", file);
          data_form.append("name", fileName);
          data_form.append("id_user_platform", this.form_update.id);
          let form = {
            url: "user_file_platform/save",
            data: data_form,
          };
          promises.push(this.createData(form));
        }

        Promise.all(promises)
          .then((responses) => {
            // Handle success
            this.deleting = false;
            this.closeUploadElement();
            this.loadUserFiles(this.form_update);
          })
          .catch((error) => {
            console.log(error);
            alert("Ocurrió un error, intente más tarde");
          })
          .finally(() => {
            Swal.close();
            Swal.fire({
              title: "Postulación actualizada correctamente",
              text: "Ahora debes esperar a que respondan tu solicitud",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            });
          });
      } else {
        Swal.fire({
          title: "No hay archivos para subir",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
      }
      this.$refs.filePond.removeFiles();
    },
    deleteStatus(data) {
      let title = "Eiminar postulación";

      let text = "¿Estás seguro de eliminar su postulación?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#B49B57",
        cancelButtonColor: "#9F9F9F",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user/user_platform/change_status",
            status: 2,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                // data.active = active;
                Swal.fire({
                  title: "La postulación fue eliminada",
                  icon: "success",
                });
                this.loadElements();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.disable-scroll {
  overflow: visible;
}
</style>
<style>
.postlation_table {
  min-width: 800px;
}
.postlation_table td:first-child {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 120px;
  width: 120px;
}
.postlation_table td:nth-child(2) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 300px;
  width: 300px;
}
.postlation_table td:nth-child(3) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 120px;
  width: 120px;
}
.postlation_table td:nth-child(4) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 300px;
  width: 300px;
}

.postlation_table td:last-child {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  justify-content: center;
  max-width: 200px;
  width: 200px;
}

.button-search {
  height: 100%;
  margin-left: 5px;
}

.my-table th:last-child {
  width: 35%;
}

.table-container {
  width: auto;
  max-width: 3000px;
  /* ajusta el valor al ancho máximo que desees */
  overflow-x: auto;
  align-items: center;
  text-align: center;
}

.l-table {
  width: 100%;
  table-layout: fixed;
}

.l-table td,
.l-table th {
  white-space: nowrap;
}

.my-button {
  margin-left: 10px;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 1px solid black;
  padding: 10px;
}

.custom-rounded-multiselect .multiselect__tags {
  border-radius: 2rem;
}

.custom-rounded-multiselect .multiselect__tags .multiselect__tag {
  border-radius: 2rem;
}

.custom-placeholder::placeholder {
  font-size: 14px;
  color: #cfcfca;
  display: inline-block;
  font-weight: 600;
}
.payment-information-header {
  border-top-left-radius: 44px;
  border-top-right-radius: 44px;
}

.modal-body-scroll {
  max-height: 70vh;
  overflow-y: auto;
}

.custom-modal-payment .modal-dialog {
  max-width: 800px;
  min-height: 600px;
}

.custom-modal-payment .modal-content {
  border-radius: 22px;
  box-shadow: 0 8px 32px rgba(53, 16, 32, 0.18);
  background: #6d263a;
  padding: 0;
  border: none;
}

.custom-modal-payment .custom-header {
  background: #6d263a;
  color: #fff;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  padding: 1.5rem 1rem 1rem 1rem;
  position: relative;
}

.custom-modal-payment .modal-body {
  background: #fff;
  border-bottom-left-radius: 22px;
  border-bottom-right-radius: 22px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.custom-modal-payment .modal-title {
  font-size: 1.6rem;
  font-weight: bold;
  letter-spacing: 1px;
}

.custom-modal-payment .custom-close {
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  color: #fff;
  font-size: 2rem;
  background: none;
  border: none;
  opacity: 1;
}

.custom-modal-payment .btn.custom-btn-main {
  background: #6d263a;
  color: #fff;
  border-radius: 12px;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0.8rem 0;
  width: 100%;
  box-shadow: 0 2px 8px rgba(109, 38, 58, 0.08);
  transition: background 0.2s;
}

.custom-modal-payment .btn.custom-btn-main:hover {
  background: #a14e5a;
}

/* Postulation Cards Styles */
.postulation-card {
  border-radius: 15px;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: 1px solid rgba(180, 155, 87, 0.15);
  overflow: hidden;
}

.postulation-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(53, 16, 32, 0.15) !important;
  border-color: rgba(180, 155, 87, 0.4);
}

.status-badge {
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 0.65rem;
  font-weight: 800;
  text-transform: uppercase;
  color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  letter-spacing: 0.5px;
}

.card-status-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
}

.badge-pending { background-color: #f39c12 !important; }
.badge-approved { background-color: #27ae60 !important; }
.badge-rejected { background-color: #D32F2F !important; }
.badge-info { background-color: #3498db !important; }
.badge-secondary { background-color: #95a5a6 !important; }

/* Payment Status Tag (Separated) */
.payment-status-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  border-left: 3px solid transparent;
}

.payment-tag-pending { 
  background-color: rgba(230, 126, 34, 0.1); 
  color: #e67e22;
  border-left-color: #e67e22;
}
.payment-tag-paid { 
  background-color: rgba(46, 204, 113, 0.1); 
  color: #2ecc71;
  border-left-color: #2ecc71;
}
.payment-tag-rejected { 
  background-color: rgba(192, 57, 43, 0.1); 
  color: #c0392b;
  border-left-color: #c0392b;
}
.payment-tag-process { 
  background-color: rgba(155, 89, 182, 0.1); 
  color: #9b59b6;
  border-left-color: #9b59b6;
}

.action-btn {
  border-radius: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.2s ease;
  padding: 8px 12px;
  border: 1px solid transparent;
}

.btn-view {
  background-color: rgba(180, 155, 87, 0.1);
  color: #b49b57;
  border-color: rgba(180, 155, 87, 0.2);
}

.btn-view:hover {
  background-color: #b49b57;
  color: white;
  transform: scale(1.03);
}

.btn-payment {
  background-color: rgba(53, 16, 32, 0.05);
  color: #351020;
  border-color: rgba(53, 16, 32, 0.1);
}

.btn-payment:hover {
  background-color: #351020;
  color: white;
  transform: scale(1.03);
}

.btn-delete {
  background-color: rgba(206, 13, 13, 0.05);
  color: #ce0d0d;
  border-color: rgba(206, 13, 13, 0.1);
}

.btn-delete:hover {
  background-color: #ce0d0d;
  color: white;
  transform: scale(1.03);
}
</style>
